<template>
  <a :href="post.url" target="_blank">
    <div class="embed-responsive embed-responsive-16by9">
      <picture
        class="embed-responsive-item img-fluid"
        :style="{ backgroundImage: `url(${post.thumb_url})`}"
      ></picture>
    </div>

    <p>{{ post.title }}</p>
  </a>
</template>

<script>
export default {
	props: {
		post: { type: Object, required: true }
	}
}
</script>

<style lang="scss" scoped>

p {
	font-size: 1.125rem;
	font-weight: 700;
	transition: all .5s;
  color: #000;
  text-align: left;
  margin-top: 5px;
}

picture {
  background-size: cover;
  background-position: center center;
}

.embed-responsive {
  border-radius: 8px;
  border: 1px solid rgba(#000, .1);
}
</style>